import Vue from 'vue';
import Router from 'vue-router';
import Products from './views/Products/Products';
import Cart from './views/Cart/Cart';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      component: () => import('./views/Standby/Standby'),
      name: 'standby',
    },
    {
      path: '/products',
      name: 'products',
      component: Products,
    },
    {
      path: '/cart',
      name: 'cart',
      component: Cart,
    },
    {
      path: '/config',
      component: () => import('./views/Settings/Settings'),
      name: 'settings',
    },
  ],
});

